import apiClient from './api';

export default {
  getDownloadsInfo() {
    return apiClient.get('/downloads/');
  }
};